import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { Person } from "@/models/person.model"
import type { IPerson } from "@/interfaces/api/person.interface"
import { PersonRepository } from "@/repositories/person-repository"
import { usePersonStore } from "@/store/persons.store"
import { storeToRefs } from "pinia"

export class PersonController extends GenericModelController<Person, IPerson, PersonRepository> {
  constructor() {
    const personStore = usePersonStore()
    const { persons } = storeToRefs(personStore)
    const storeFunctionsConfig = {
      collection: persons
    }
    super(Person, storeFunctionsConfig, new PersonRepository())
  }
}
